import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/mn.ts
var add = "Нэмэх";
var remove = "Хасах";
var removeAll = "Бүгдийг хасах";
var incomplete = "Уучлраарай, зарим нүдэн дахь өгөгдөл дутуу байна.";
var submit = "Илгээх";
var noFiles = "Файл сонгоогүй байна";
var moveUp = "Дээшээ";
var moveDown = "Доошоо";
var isLoading = "Ачааллаж байна...";
var loadMore = "Нэмж ачааллах";
var next = "Дараагийн";
var prev = "Өмнөх";
var addAllValues = "Бүх утгуудыг нэмэх";
var addSelectedValues = "Сонгогдсон утгуудыг нэмэх";
var removeAllValues = "Бүх утгуудыг устгах";
var removeSelectedValues = "Сонгогдсон утгуудыг хасах";
var chooseDate = "Огноо сонгох";
var changeDate = "Огноо өөрчлөх";
var close = "Хаах";
var open = "Нээлттэй";
var accepted = function({
  name
}) {
  return `${name} утгыг зөвшөөрнө үү.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} нь ${date(args[0])}-ны дараа орох ёстой.`;
  }
  return `${sentence(name)} утга ирээдүйг заах ёстой.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} зөвхөн үсэг агуулах ёстой.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} зөвхөн үсэг болон тоог агуулах ёстой.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} зөвхөн үсэг болон зай агуулах ёстой.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} нь ${date(args[0])}-ны өмнө байх ёстой.`;
  }
  return `${sentence(name)} өнгөрсөн огноо байх ёстой.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Энэ нүдэн дэхь өгөгдөл буруу учраас илгээх боломжгүй.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} нь заавал ${a}, ${b} хоёрын дунд байх ёстой.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} таарахгүй байна.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} нь хүчинтэй огноо биш тул ${args[0]} гэсэн огноог ашиглаарай.`;
  }
  return "Энэхүү нүд буруу тул цааш илгээх боломжгүй.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} нь заавал ${date(args[0])}, ${date(args[1])} хоёр огноон дунд байх ёстой.`;
};
var email = "Та хүчинтэй имейл хаягаа оруулна уу.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} нь ${list(args)} гэсэн утгаар төгсөөгүй байна.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} нь зөвшөөрөгдөх утга биш.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} дээр хаяж нэг үсэг байх ёстой`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)}-н урт нь ${max2}-ээс ихгүй байх ёстой.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} нь ${max2} урт байвал зүгээр.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)}-н урт нь ${min2}-ээс их буюу тэнцүү байж болно.`;
  }
  return `${sentence(name)}-н урт нь ${min2}, ${max2} хоёрын дунд байх ёстой.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} нь зөвшөөрөгдөх утга биш.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} нь ${args[0]}-аас их байж болохгүй.`;
  }
  return `${sentence(name)} нь ${args[0]}-тай тэнцүү эсвэл бага байх ёстой.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Файлын формат буруу.";
  }
  return `${sentence(name)} төрөл нь ${args[0]} байх ёстой.`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} нь ${args[0]}-аас их байж болохгүй.`;
  }
  return `${name} нь дор хаяж ${args[0]}-тай тэнцүү байх ёстой.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” бол зөвшөөрөгдөх ${name} гэсэн утга биш.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} зөвхөн тоо байх ёстой.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} байх ёстой.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} нь ${list(args)}-ээр эхлээгүй байна.`;
};
var url = function() {
  return `Хүчннтай URL оруулна уу.`;
};
var invalidDate = "Сонгосон огноо буруу байна.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  required,
  starts_with,
  url,
  invalidDate
};
var mn_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, date_after, date_before, date_between, date_format, mn_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, required, starts_with, submit, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=mn.mjs.map